/**
 * Least to most advanced, so a stage array can be sorted into reading order.
 *
 * These are literal tuples rather than `readonly Stage[]` so `z.enum()` can be
 * built from them; `satisfies` still fails the build if the database enum and
 * this list drift apart.
 */
export const STAGES = [
    'pre_seed',
    'seed',
    'series_a',
    'series_b',
    'series_c_plus',
];
export const LEAD_STATUSES = [
    'leads',
    'follow_only',
    'selective',
    'unknown',
];
/**
 * Whether a fund is on the list Project A works from or in the pool of firms it
 * has only come across. Stored, and only ever promoted automatically.
 */
export const LIST_STATUSES = ['list', 'pool'];
export const WARMTHS = [
    'strong',
    'warm',
    'lukewarm',
    'cold',
    'unknown',
];
export const RELATIONSHIP_SOURCES = [
    'sheet',
    'affinity',
    'manual',
    'research',
    'dealroom',
    'reported',
    'affinity_contact',
];
/** How a reported contact happened, in the order the pane's select offers them. */
export const CONTACT_CHANNELS = [
    'meeting',
    'call',
    'email',
    'event',
    'intro',
    'other',
];
/** Which write path filed a report: the Slack automation, an agent, the pane. */
export const CONTACT_REPORT_SOURCES = [
    'slack',
    'mcp',
    'manual',
];
export const CONTACT_REPORT_STATUSES = [
    'matched',
    'needs_review',
    'ignored',
];
export const IMPORT_SOURCES = [
    'marjorie_sheet',
    'claude_sheet',
];
const stageNames = new Set(STAGES);
const warmthNames = new Set(WARMTHS);
export function isStage(value) {
    return stageNames.has(value);
}
export function isWarmth(value) {
    return warmthNames.has(value);
}
/**
 * WARMTHS is declared best first, so its index is the "who knows them best"
 * ordering. Affinity strength joins it as a tiebreak once the sync exists.
 */
export function compareWarmth(left, right) {
    return WARMTHS.indexOf(left) - WARMTHS.indexOf(right);
}
/** Canonical order, deduplicated. */
export function sortStages(stages) {
    return STAGES.filter((stage) => stages.includes(stage));
}
//# sourceMappingURL=enums.js.map